import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions} from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Rx';
import { AppConfig } from 'app/app.config';
import { environment } from 'environments/environment';

@Injectable()
export class ConvocatoriaService {

  constructor(private http: Http, private config: AppConfig) { }

  getDOCUMENTACION(idconvocatoria, idtipodocumento) {
    const parametros = idconvocatoria  ;
    console.log(this.jwtBlob());
    let action= '';
    if (idtipodocumento==1){  action = '/convocatoria/evidencias/';}
    if (idtipodocumento==2){  action = '/convocatoria/cuestionario/';}
    if (idtipodocumento==3){  action = '/convocatoria/guia/';}
    console.log(environment.apiUrl + action + parametros);
    return this.http.get(environment.apiUrl + action + parametros, this.jwtBlob()).map((response: Response) => response.text());
  
  }


  getExcelValoraciones(idconvocatoria) {
    const parametros = idconvocatoria  ;
    console.log(this.jwtBlob());
    console.log(environment.apiUrl + '/excel/' + parametros);
    return this.http.get(environment.apiUrl + '/excel/' + parametros, this.jwtBlob()).map((response: Response) => response.text());
  
  }

  getAll(tipo,activa) {
    console.log(environment.apiUrl + '/convocatoria/'+tipo);
    return this.http.get(environment.apiUrl + '/convocatoria/'+tipo+'/'+activa , this.jwt()).map((response: Response) => response.json());
  
  }


  put(idconvocatoria,tipo,FORM_CONVOCATORIA) {
    console.log(environment.apiUrl + '/convocatoria/'+idconvocatoria+'/'+tipo);
    return this.http.put(environment.apiUrl + '/convocatoria/'+idconvocatoria+'/'+tipo ,{convocatoria: FORM_CONVOCATORIA}, this.jwt()).map((response: Response) => response.json());
  
  }

  putAll(tipo,FORM_CONVOCATORIA) {
    console.log(environment.apiUrl + '/convocatoria/'+tipo);
    return this.http.put(environment.apiUrl + '/convocatoria/'+tipo+'/0' ,FORM_CONVOCATORIA, this.jwt()).map((response: Response) => response.json());
  
  }

  
  getTiposEvaluacion(idconvocatoria) {
    console.log(environment.apiUrl + '/convocatoria/tiposEvaluacion/'+idconvocatoria);
    return this.http.get(environment.apiUrl + '/convocatoria/tiposEvaluacion/'+idconvocatoria , this.jwt()).map((response: Response) => response.json());
  
  }

  private jwtBlob() {
    // create authorization header with jwt token
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.token) {
        const headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token });
        // headers = new Headers({ResponseContentType : Text});
        return new RequestOptions({ headers: headers });
    }
  }

  private jwt() {
    // create authorization header with jwt token
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.token) {
        const headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token });
        return new RequestOptions({ headers: headers });
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/convocatoria.service.ts